import { render, staticRenderFns } from "./ResumeCreate.vue?vue&type=template&id=d472880c&"
import script from "./ResumeCreate.vue?vue&type=script&lang=js&"
export * from "./ResumeCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports